<template>
  <div class="p-5">
    <div class="flex items-start gap-4">
      <div class="flex-1">
        <div class="flex justify-center items-center min-h-[220px]">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-5xl">
            <button
              v-for="option in options"
              :key="option.value"
              type="button"
              class="group cursor-pointer app-card-glass dark:bg-transparent shadow-md flex flex-col items-center justify-center text-center rounded-2xl p-6 min-h-[160px] transition-all duration-200"
              :class="
                modelValue === option.value
                  ? 'bg-[var(--p-primary-color)]/10 shadow-md scale-[1.02]'
                  : 'hover:bg-[var(--p-primary-50)]/50 dark:hover:bg-[var(--p-primary-800)]/10 hover:shadow-lg'
              "
              @click="$emit('update:modelValue', option.value)"
            >
              <div
                class="flex items-center justify-center w-14 h-14 rounded-full mb-4 transition-colors"
                :class="
                  modelValue === option.value
                    ? 'bg-[var(--p-primary-color)] text-white dark:text-[var(--p-surface-100)]'
                    : 'bg-[var(--p-primary-50)]/30 shadow-sm dark:bg-[var(--p-primary-900)]/70 '
                "
              >
                <component :is="option.icon" width="24" height="24" class="text-[var(--p-primary-color)] dark:text-[var(--p-surface-0)]" />
              </div>

              <span
                class="montserrat text-md font-semibold text-[var(--p-primary-color)] dark:text-[var(--p-text-color)]"
              >
                {{ option.label }}
              </span>
              <span
                class="mt-2 text-xs text-[var(--p-surface-500)] dark:text-[var(--p-surface-100)]"
              >
                {{ option.description }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import IconAgent from '@/assets/svg/agent_icon.svg?component'
import IconBot from '@/assets/svg/bot_icon.svg?component'
import IconCampaing from '@/assets/svg/campaign_icon.svg?component'

type TransferType = 'campaign' | 'user' | 'bot'

interface Props {
  modelValue: TransferType | null
}

defineProps<Props>()

defineEmits<{
  'update:modelValue': [value: TransferType]
}>()

const { t } = useI18n()

const options = computed(() => [
  {
    value: 'user' as const,
    label: t('whatsapp.agent'),
    description: t('whatsapp.agent_transfer_description'),
    icon: IconAgent,
  },
  {
    value: 'campaign' as const,
    label: t('whatsapp.campaing'),
    description: t('whatsapp.campaing_transfer_description'),
    icon: IconCampaing,
  },
  {
    value: 'bot' as const,
    label: t('whatsapp.bot'),
    description: t('whatsapp.bot_transfer_description'),
    icon: IconBot,
  },
])
</script>
